import TwoColumnsWithSquareImage from '@/components/TwoColumnsWithSquareImage'

export default function PlugInAPI() {
    return (
        <TwoColumnsWithSquareImage
            title={'Effortlessly plug into a simple and scalable API'}
            paragraph={`Seamlessly embed emissions tracking into your user-experience. Lune customers integrate our API within hours, further accelerated by optional support from our engineers.`}
            image={{
                src: '/images/pluginapi.png',
                alt: 'Effortlessly plug into a simple and scalable API',
            }}
        />
    )
}
